<template lang="pug">
  div.content
    b-table.is-paddingless-detail(
      v-if="type === 'table'"
      :data="statistic.rows"
      :detailed="options.detailed"
      :loading="isLoading"
      detailed-key="id"
    )
      //- template(v-slot="{row}")
      b-table-column(
        v-for="(label, name) in statistic.columns"
        :key="name"
        :label="label"
        :field="name"
        :sortable="options.sortable"
        v-slot="{row}"
        sticky-header
      )
        span(:class="row.options ? row.options.style : []")
          statistic-data(:value="row[name]")

      b-table-column(v-if="expanded" v-slot="{row}")
        b-button.mr-10(v-if="hasExport" @click="getExportFile(row)" size="is-small" rounded)
          b-icon.mr-5(icon="share")
          span Экспорт
        span(@click="$emit('expand', row.id)")
          b-icon.expand(icon="arrow-right" type="is-primary")

      template(<template slot="detail" slot-scope="{row}")
        b-table.is-light(:data="row.detailed.rows" narrowed)
            b-table-column(
              v-for="(label, name) in row.detailed.columns"
              :key="name"
              :label="label"
              :field="name"
              :sortable="options.sortable"
              v-slot="props"
            )
              statistic-data(:value="props.row[name]")

            b-table-column(v-if="expanded" v-slot="props")
              span(@click="$emit('expand', row.id, props.row.id)")
                b-icon.expand(icon="arrow-right" type="is-primary")

      template(v-slot:empty)
        section.section(v-if="!isLoading")
          .content.has-text-grey.has-text-centered
            p: b-icon(icon="emoticon-sad" size="is-large")
            p Нет записей
</template>

<script>
import api from '@/api';
import StatisticData from '@/components/StatisticData';

export default {
  name: 'statistic',

  components: {
    StatisticData,
  },

  props: {
    url: {
      type: String,
      default: '/statistics',
    },
    hasExport: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    type: null,
    isLoading: false,
    statistic: {},
    options: {},
  }),

  watch: {
    url() {
      this.fetch();
    },
  },

  methods: {
    async fetch() {
      this.isLoading = true;

      // @todo pagination
      const { data } = await api.for(this.url).fetch();

      this.type = data.type;
      this.statistic = data.data;
      this.options = data.options;
      this.isLoading = false;
    },

    async getExportFile({ id }) {
      const exportUrl = `${this.url}/${id}/export`;
      const result = await api.for(exportUrl).fetch();

      if (result.file) {
        window.location = '/api' + result.file;
      }
    },
  },

  mounted() {
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
.expand {
  cursor: pointer;
}
.success {
  background-color: hsl(141, 71%, 48%);
}
</style>
